import { ReactComponent as BackgroundTriangles } from "../assets/images/background-triangles.svg";

const images = {
  BackgroundTriangles,
};

export default images;
